import type { TableRow } from 'mdast';
import type { State } from '../state';

export function tableRow(state: State, node: TableRow, index: number): void {
	const nodeType = state.schema.nodes.tableRow ?? state.schema.nodes.table_row;
	if (!nodeType) {
		// Gracefully degrade: schema has no tableRow node — render cells directly
		state.rowIndex = index;
		state.parseTokens(node.children);
		state.rowIndex = null;
		return;
	}
	state.openNode(nodeType);
	state.rowIndex = index;
	state.parseTokens(node.children);
	state.rowIndex = null;
	state.closeNode();
}
